// Llaves de caché de las lecturas MDM. Viven juntas para que las mutaciones invaliden todas.

/** La flota paginada de Control MDM (`useInfiniteQuery`). */
export const MDM_FLEET_KEY = ['mdm-fleet'] as const;

/** El expediente MDM de UN crédito que lee la ficha; se completa con el `creditId`. */
export const CREDIT_FILE_DEVICE_KEY = ['credit-file', 'mdm-device'] as const;

/** La bitácora de un equipo; se completa con el `creditId`. */
export const MDM_OPERATIONS_KEY = ['mdm-device-operations'] as const;
